export default {
    install(Vue, options) {
        Vue.prototype.getDateDiff = function (timestamp) {
            //获取当天零点的毫秒数
            let zeroTime = new Date(new Date().toLocaleDateString()).getTime();
            //获取昨天零点的毫秒数
            let yesterdayZeroTime = zeroTime - 86400*1000;
            let minute = 1000 * 60;
            let hour = minute * 60;
            let day = hour * 24;
            let now = new Date().getTime();
            let diffValue = now - timestamp;
            let result = '';
            if (diffValue < 0) {
                return;
            }
            let dayC = diffValue / day;
            let hourC = diffValue / hour;
            let minC = diffValue / minute;
            //获取当前的年份
            let fullYear = new Date().getFullYear();
            //获取时间戳转化出来的年月日
            let newDate = new Date(timestamp);
            let year = newDate.getFullYear();
            let month = newDate.getMonth() + 1;
            let date = newDate.getDate();
            //月日补零
            month = (month < 10) ? '0' + month : month;
            date = (date < 10) ? '0' + date : date;
            if (minC <= 2){
                result = "刚刚";
            } else if (minC <= 60){
                result = '' + parseInt(minC) + "分钟前";
            } else if (hourC > 1 && timestamp > zeroTime){
                result = '' + parseInt(hourC) + "小时前";
            } else if (yesterdayZeroTime < timestamp && timestamp < zeroTime){
                result = "昨天";
            } else if (year == fullYear){
                result =  month + '/' + date;
            } else {
                result = year + '/' + month + '/' + date;
            }
            return result;
        }
    }
}



// WEBPACK FOOTER //
// ./src/utils/Interval.js